// extracted by mini-css-extract-plugin
module.exports = {"panel":"Disclosure_panel__j73YG","slide-down":"Disclosure_slide-down__4A9Tf"};